<!--
Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.

NVIDIA CORPORATION and its licensors retain all intellectual property
and proprietary rights in and to this software, related documentation
and any modifications thereto.  Any use, reproduction, disclosure or
distribution of this software and related documentation without an express
license agreement from NVIDIA CORPORATION is strictly prohibited.
-->

<div class="post-launch-button-container">
    @for (topic of topics; track topic) {
        @if (showButton(topic)) {
            <button mat-flat-button class="font-button2">
                <a href="{{ getTopicPath(topic) }}" target="_blank">{{ getButtonTitle(topic) }}</a>
            </button>
        }
    }
</div>
